import { render, staticRenderFns } from "./ToolMarkdown.vue?vue&type=template&id=1d127e34&"
import script from "./ToolMarkdown.vue?vue&type=script&lang=js&"
export * from "./ToolMarkdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports